import { DateTime } from 'luxon'
import { TypographyStyles } from '@/styles'
import { Text } from '@/ui'

export const BecomeSCorpPopupContent = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Becoming an S Corporation</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      Was your business an S Corporation from January 1, {DateTime.now().year},
      through December 31, {DateTime.now().year}? If you elected S Corporation
      status partway through the year, did you receive approval for full-year S
      Corporation status?
    </Text>
  </>
)

export const CommingledBankingPopupContent = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Commingled banking activity</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      If you have personal and business transactions in the same bank account,
      select <b>Personal bank account</b>.
    </Text>
  </>
)

export const SeperateBankingPopupContent = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>
      Separating your personal and business banking activity
    </Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      Paying for business and personal expenses from the same account puts your
      practice at risk.
    </Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      We&apos;ll guide you through separating your transactions after
      you&apos;ve signed up.
    </Text>
  </>
)

export const MultipleOwnersPopupContent = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Multiple owners</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      Heard is a best fit for:
      <ul className="list-disc pl-6">
        <li>Professionals reporting income as a solo practitioner</li>
        <li>Independent contractors working for a group practice</li>
        <li>
          Sole-legal owners of a group practice (with no co-owners) with 0-9
          employees
        </li>
      </ul>
    </Text>
  </>
)

export const EmployeeCountPopupContent = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Number of employees</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      If you have more than 10 full-time employees, select <b>Yes</b>.
    </Text>
  </>
)

export const InternationalTaxPopupContent = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>International taxes</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      If you see international clients and your practice pays taxes to countries
      other than the United States (including U.S. territories) select{' '}
      <b>Yes</b>.
    </Text>
  </>
)

export const PhysicalInventoryPopupContent = () => (
  <>
    <Text variant={TypographyStyles.LABEL_MD}>Physical inventory</Text>
    <Text variant={TypographyStyles.BODY_SM} className="mt-2">
      e.g. books, supplements, rehab equipment, massage tools, or other items
      you keep in stock to sell to clients
    </Text>
  </>
)
